import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useSearchParams} from "react-router-dom";
import Pagination from "react-js-pagination";

export default function Agency(prop) {
    let [searchParams] = useSearchParams();

    let [data, setData] = React.useState(null);
    let [listing, setListing] = React.useState(null);
    let [agencyType, setAgencyType] = React.useState(null);
    let [product, setProduct] = React.useState(null);
    let [service, setService] = React.useState(null);
    let [agencyTypeId, setAgencyTypeId] = React.useState('');
    let [productId, setProductId] = React.useState('');
    let [serviceId, setServiceId] = React.useState('');

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);

    let refKeyword = React.useRef();

    React.useEffect(() => {
        let title = (prop.lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน') + ' | NCSA';
        document.title = title;
        const elDesc = document.querySelector("meta[name='description']");
        elDesc.setAttribute('content', title);
        const elOgTitle = document.querySelector("meta[property='og:title']");
        elOgTitle.setAttribute('content', title);
        const elOgDesc = document.querySelector("meta[property='og:description']");
        elOgDesc.setAttribute('content', title);
        const elOgImage = document.querySelector("meta[property='og:image']");
        elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
        const elOgUrl = document.querySelector("meta[property='og:url']");
        elOgUrl.setAttribute('content', window.location.href);

        if(searchParams.get('agencyTypeId')) {
            setAgencyTypeId(searchParams.get('agencyTypeId'));
        }
        else {
            setAgencyTypeId(null);
        }
        if(searchParams.get('productId')) {
            setProductId(searchParams.get('productId'));
        }
        else {
            setProductId(null);
        }
        if(searchParams.get('serviceId')) {
            setServiceId(searchParams.get('serviceId'));
        }
        else {
            setServiceId(null);
        }
        if(searchParams.get('keyword')) {
            refKeyword.current.value = searchParams.get('keyword');
        }
        else {
            refKeyword.current.value = '';
        }

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resAgencyType = await getAgencyType();
                setAgencyType(resAgencyType);

                const resProduct = await getProduct();
                setProduct(resProduct);

                const resService = await getService();
                setService(resService);

                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }
            } catch (e) {
                //
            }
        })();
    }, [searchParams]);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    const onChangeAgencyType = (e) => {
        setAgencyTypeId(e.target.value);
    };

    const onChangeProduct = (e) => {
        setProductId(e.target.value);
    };

    const onChangeService = (e) => {
        setServiceId(e.target.value);
    };

    const onSearch = (e) => {
        let param = [];
        if(refKeyword.current.value) {
            param.push('keyword=' + refKeyword.current.value);
        }
        if(agencyTypeId !== null) {
            param.push('agencyTypeId=' + agencyTypeId);
        }
        if(productId !== null) {
            param.push('productId=' + productId);
        }
        if(serviceId !== null) {
            param.push('serviceId=' + serviceId);
        }
        window.location = (prop.lang === 'en' ? '/en': '/') + 'agency' + (param.length > 0 ? '?' + param.join('&') : '');
    };

    async function getView() {
        const response = await fetch(Config.apiUrl +'/agencyBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        let newAgencyTypeId = null;
        let newProductId = null;
        let newServiceId = null;
        if(searchParams.get('agencyTypeId')) {
            newAgencyTypeId = searchParams.get('agencyTypeId');
        }
        if(searchParams.get('productId')) {
            newProductId = searchParams.get('productId');
        }
        if(searchParams.get('serviceId')) {
            newServiceId = searchParams.get('serviceId');
        }

        const response = await fetch(Config.apiUrl +'/agency/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                keyword: refKeyword.current.value,
                agencyTypeId: newAgencyTypeId,
                productId: newProductId,
                serviceId: newServiceId,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getAgencyType() {
        const response = await fetch(Config.apiUrl +'/agencyType/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getProduct() {
        const response = await fetch(Config.apiUrl +'/product/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getService() {
        const response = await fetch(Config.apiUrl +'/service/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'agency_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน'}</span>
                    </h1>

                    <div className="form-group search mt-sm-4 mt-2" data-aos="fade-in">
                        <input type="text" className="form-control" placeholder={prop.lang === 'en' ? 'Find Agency':'ค้นหาข้อมูลหน่วยงาน'} ref={refKeyword} />
                        <button className="btn btn-search" type="button" onClick={onSearch}>{prop.lang === 'en' ? 'Search':'ค้นหา'}</button>
                    </div>
                </div>
            </div>

            <div className="section">
                <div className="container has-sidebar" data-aos="fade-in">
                    <div className="sidebar">
                        <h3 className="fs-20 mb-lg-4 mb-2">{prop.lang === 'en' ? 'Filters':'ตัวกรอง'}</h3>
                        <div className="row g-lg-4 g-3">
                            {
                                agencyType !== null && agencyType.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Type':'ประเภท'}</h6>
                                            <select className="form-select" onChange={onChangeAgencyType} defaultValue={agencyTypeId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    agencyType.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                product !== null && product.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Product':'ผลิตภัณฑ์'}</h6>
                                            <select className="form-select" onChange={onChangeProduct} defaultValue={productId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    product.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            {
                                service !== null && service.count > 0 ?
                                    <div className="col-lg-12 col-md-4">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Service':'บริการ'}</h6>
                                            <select className="form-select" onChange={onChangeService} defaultValue={serviceId}>
                                                <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                                {
                                                    service.rows.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }

                            <div className="col-12">
                                <button className="btn w-100 my-2" type="button" onClick={onSearch}>{prop.lang === 'en' ? 'Search':'แสดงผลการค้นหา'}</button>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="hgroup" data-aos="fade-in">
                            <div className="d-flex">
                                <div>
                                    <h2>{prop.lang === 'en' ? 'Search results':'ผลการค้นหา'}</h2>
                                    <p className="m-0 d-none">{prop.lang === 'en' ? 'Results':'รายการที่ 1 ถึง 10 จาก ' + countAllItem + ' รายการ'}</p>
                                </div>
                                <div className="show-list d-none">
                                    <p>{prop.lang === 'en' ? 'Show list':'แสดงรายการ'}</p>
                                    <select className="form-select">
                                        <option>10</option>
                                    </select>
                                </div>
                            </div>
                            <hr />
                        </div>

                        {
                            listing !== null && listing.count > 0 ?
                                <>
                                    <div className="row g-3">
                                        {
                                            listing.rows.map((row, index) => {
                                                return (
                                                    <div key={index} className="col-12">
                                                        <div className="card-infos" data-aos="fade-in">
                                                            <h3 className="fs-20"><NavLink to={(prop.lang === 'en' ? '/en':'') + '/agency/detail/' + row.slug} className="link-title">{prop.lang === 'en' ? row.title_en:row.title}</NavLink>
                                                            </h3>
                                                            <ul className="infos-list">
                                                                {
                                                                    row.agencyType ?
                                                                    <li>
                                                                        <h6>{prop.lang === 'en' ? 'Type':'ประเภท'} :</h6>
                                                                        <p>{prop.lang === 'en' ? row.agencyType.title_en:row.agencyType.title}</p>
                                                                    </li> : ''
                                                                }
                                                                {
                                                                    row.product ?
                                                                    <li>
                                                                        <h6>{prop.lang === 'en' ? 'Product':'ผลิตภัณฑ์'} :</h6>
                                                                        <p>{prop.lang === 'en' ? row.product.title_en:row.product.title}</p>
                                                                    </li> : ''
                                                                }
                                                                {
                                                                    row.service ?
                                                                    <li>
                                                                        <h6>{prop.lang === 'en' ? 'Service':'บริการ'} :</h6>
                                                                        <p>{prop.lang === 'en' ? row.service.title_en:row.service.title}</p>
                                                                    </li> : ''
                                                                }
                                                                <li className="d-none">
                                                                    <h6 className="pt-sm-1">ผลงาน :</h6>
                                                                    <div className="button-list">
                                                                        <a className="btn">ผลงานตีพิมพ์ : 0</a>
                                                                        <label className="btn" href="#">สิทธิบัตร :
                                                                            0</label>
                                                                        <label className="btn">โครงการ : 0</label>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>

                                    <div className={totalPage > 1 ? '':'d-none'}>
                                        <Pagination
                                            itemClassPrev="arrow prev"
                                            itemClassNext="arrow next"
                                            activeClass="active"
                                            itemClass=""
                                            linkClass=""
                                            innerClass="pagination justify-content-sm-end py-4 my-3"
                                            activePage={activePage}
                                            itemsCountPerPage={itemPerpage}
                                            totalItemsCount={countAllItem}
                                            pageRangeDisplayed={5}
                                            onChange={(pageNum) => onPageChange(pageNum)}
                                        />
                                    </div>
                                </> : <p>{prop.lang === 'en' ? 'Not found':'ไม่พบข้อมูล'}</p>
                        }
                    </div>
                </div>
            </div>
        </>
    );
} 